import { ViewController } from 'elc-service';
import { computed, action, observable } from 'mobx';
import { FilterSet } from '../domain/entities/FilterSet';

export class ProductFiltersViewController extends ViewController {
    @observable private isFiltersModalOpen: boolean = false;
    @observable private isFilterInProgress: boolean = false;

    @computed
    get data() {
        return {
            isFiltersModalOpen: this.isFiltersModalOpen,
            isFilterInProgress: this.isFilterInProgress
        };
    }

    @action
    public onClearAllAppliedFilters(filtersSets: FilterSet[]) {
        filtersSets.forEach(filterSet => filterSet.clearAllFilters());
    }

    @action
    public onOpenFiltersClick = () => {
        this.isFiltersModalOpen = true;
    };

    @action
    public onCloseFiltersClick = () => {
        this.isFiltersModalOpen = false;
    };
}
